// Regional guides for IPTV with country-specific channels, pricing, and legal framework
export const regionalGuides = {
  usa: {
    id: 'usa',
    country: 'United States',
    currency: 'USD',
    overview: 'IPTV in USA provides access to major sports leagues, news networks, and international content.',
    channels: {
      sports: ['NFL', 'NBA', 'NHL', 'MLB', 'MLS', 'NCAA', 'PGA Golf', 'UFC', 'Boxing'],
      news: ['CNN', 'Fox News', 'MSNBC', 'Bloomberg', 'CNBC', 'NBC News', 'ABC News', 'CBS News'],
      entertainment: ['HBO', 'Showtime', 'Starz', 'CBS', 'NBC', 'ABC', 'Fox', 'Disney+', 'Netflix'],
      international: ['BBC', 'Sky Sports', 'Eurosport', 'beIN Sports', 'Premium sports channels']
    },
    pricing: {
      currency: 'USD',
      typical: '$9.99 - $14.99/month',
      sports_premium: '$14.99 - $19.99/month',
      trial: 'Free 24 hours'
    },
    legal: 'Depends on provider licensing. Licensed providers operate legally. Users responsible for selecting legitimate services.',
    popular_content: ['NFL Sunday', 'March Madness', 'NBA Playoffs', 'World Series', 'MLS Cup', 'Golf Majors'],
    internet_requirement: '10+ Mbps for HD, 25+ Mbps for 4K',
    best_devices: ['Firestick 4K', 'Roku Ultra', 'Apple TV 4K', 'Samsung TV'],
    faq: [
      { q: 'Is IPTV legal in USA?', a: 'Licensed providers are legal. Verify provider legitimacy before subscribing.' },
      { q: 'Best for sports?', a: 'IPTV superior to cable for sports without blackouts' },
      { q: 'Can I watch regional sports?', a: 'Yes, IPTV includes all regional sports networks' }
    ]
  },
  canada: {
    id: 'canada',
    country: 'Canada',
    currency: 'CAD',
    overview: 'IPTV in Canada provides access to NHL, CFL, Canadian channels, and international content.',
    channels: {
      sports: ['NHL', 'CFL', 'NBA', 'MLB', 'MLS', 'TSN', 'Sportsnet', 'CBC Sports', 'UFC'],
      news: ['CTV News', 'CBC News', 'Global News', 'CP24', 'BNN Bloomberg', 'CNN', 'BBC'],
      entertainment: ['CTV', 'CBC', 'Global', 'Citytv', 'TVA', 'Comedy Network', 'Showcase'],
      canadian_exclusive: ['Maple Leafs Games', 'Canucks Games', 'Hockey Night in Canada', 'Toronto Raptors']
    },
    pricing: {
      currency: 'CAD',
      typical: '$13.99 - $19.99 CAD/month',
      sports_premium: '$19.99 - $24.99 CAD/month',
      trial: 'Free 24 hours'
    },
    legal: 'IPTV legal status complex in Canada. Licensed providers recommended. Users responsible for service verification.',
    popular_content: ['Toronto Maple Leafs', 'Hockey Night in Canada', 'CFL Games', 'NBA Toronto Raptors', 'Grey Cup'],
    internet_requirement: '10+ Mbps for HD, 25+ Mbps for 4K',
    best_devices: ['Firestick', 'Roku', 'Apple TV', 'Samsung TV'],
    faq: [
      { q: 'Is IPTV legal in Canada?', a: 'Providers licensed for Canadian distribution operate legally' },
      { q: 'Best for hockey?', a: 'Excellent NHL coverage with all games available' },
      { q: 'Can I get US channels?', a: 'Yes, many packages include US networks' }
    ]
  },
  uk: {
    id: 'uk',
    country: 'United Kingdom',
    currency: 'GBP',
    overview: 'IPTV in UK provides access to BBC, Sky Sports, Premier League football, and international content.',
    channels: {
      sports: ['Premier League', 'Champions League', 'Sky Sports', 'BT Sport', 'Eurosport', 'Tennis', 'Golf', 'F1'],
      news: ['BBC News', 'Sky News', 'ITV News', 'Channel 4 News', 'France24', 'Euronews'],
      entertainment: ['BBC One', 'BBC Two', 'ITV', 'Channel 4', 'Channel 5', 'Sky Atlantic', 'Now TV'],
      bbc_content: ['BBC iPlayer', 'Doctor Who', 'Sherlock', 'Top Gear', 'Strictly']
    },
    pricing: {
      currency: 'GBP',
      typical: '£7.99 - £11.99/month',
      sports_premium: '£11.99 - £15.99/month',
      trial: 'Free 24 hours'
    },
    legal: 'IPTV legal status strict in UK. Licensed providers only. BBC content protected by licensing restrictions.',
    popular_content: ['Premier League Football', 'Champions League', 'Wimbledon', 'Formula 1', 'Strictly Come Dancing'],
    internet_requirement: '10+ Mbps for HD, 25+ Mbps for 4K',
    best_devices: ['Firestick', 'Roku', 'Apple TV', 'Smart TV'],
    faq: [
      { q: 'Can I access BBC iPlayer?', a: 'Limited access depends on VPN/location authenticity' },
      { q: 'Best for Premier League?', a: 'Sky Sports packages include comprehensive coverage' },
      { q: 'Is IPTV legal in UK?', a: 'Licensed providers legal. Pirate IPTV illegal.' }
    ]
  },
  australia: {
    id: 'australia',
    country: 'Australia',
    currency: 'AUD',
    overview: 'IPTV in Australia provides access to NRL, AFL, cricket, tennis, and international sports.',
    channels: {
      sports: ['NRL', 'AFL', 'Cricket', 'Tennis', 'Rugby Union', 'Motorsports', 'Golf', 'Soccer'],
      news: ['ABC News', '7 News', '9 News', 'Ten News', 'SBS News', 'BBC News'],
      entertainment: ['ABC', '7', '9', '10', 'SBS', 'Foxtel', 'Stan', 'Binge'],
      australian_exclusive: ['State of Origin', 'Australian Open', 'Bathurst 1000', 'Melbourne Cup']
    },
    pricing: {
      currency: 'AUD',
      typical: '$14.99 - $19.99 AUD/month',
      sports_premium: '$19.99 - $24.99 AUD/month',
      trial: 'Free 24 hours'
    },
    legal: 'IPTV legal status depends on content licensing. Licensed providers recommended. Verify legitimacy.',
    popular_content: ['State of Origin', 'AFL Grand Final', 'Australian Open Tennis', 'Boxing Day Cricket', 'NRL Playoffs'],
    internet_requirement: '10+ Mbps for HD, 25+ Mbps for 4K',
    best_devices: ['Firestick', 'Roku', 'Apple TV', 'Samsung Smart TV'],
    faq: [
      { q: 'Best for NRL/AFL?', a: 'IPTV includes all games with no blackouts' },
      { q: 'Can I get Asian content?', a: 'Yes, many packages include Asian sports/entertainment' },
      { q: 'What\'s the timezone?', a: 'AEDT/AEST - live sports often at convenient times for Asia/Europe' }
    ]
  }
};

export const regionPriority = ['usa', 'uk', 'canada', 'australia'];
